import { dollars } from './buildings';

/*
 * Celebrations: the airport's 100th departure, its 500th, its 1000th and so on are marked with
 * fireworks, a cake in the terminal and a little money from the airport's owners. Counted from
 * the departures already on record, so nothing new needs saving.
 */

/** Departure counts worth a celebration, and what each brings. */
export const DEPARTURE_MILESTONES: readonly { readonly at: number; readonly reward: number }[] = [
  { at: 100, reward: dollars(10_000) },
  { at: 500, reward: dollars(30_000) },
  { at: 1000, reward: dollars(60_000) },
  { at: 2500, reward: dollars(120_000) },
  { at: 5000, reward: dollars(200_000) },
  { at: 10_000, reward: dollars(350_000) },
  { at: 25_000, reward: dollars(600_000) },
  { at: 50_000, reward: dollars(1_000_000) },
];

/** The celebration a departure count reaches exactly, if any. */
export function departureMilestone(departures: number): { at: number; reward: number } | null {
  return DEPARTURE_MILESTONES.find((m) => m.at === departures) ?? null;
}
